
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 22","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"11","cy":"11","r":"11","fill":"#255C9B"}}),_c('path',{attrs:{"d":"M9.83 5.8h2.367l-.4 7.488h-1.584L9.83 5.8zm1.183 11.312c-.373 0-.682-.117-.928-.352a1.22 1.22 0 01-.368-.896c0-.352.123-.645.368-.88.246-.235.555-.352.928-.352.363 0 .662.117.896.352.246.235.368.528.368.88s-.122.65-.368.896c-.234.235-.533.352-.896.352z","fill":"#fff"}})])
          )
        }
      }
    